import React, { createRef, useContext, useEffect, useState } from 'react';
import { Header } from './Header';
import { PageSummary } from './PageSummary';
import { FilterBar } from '../FilterBar';
import { Models } from '../Filtering/common/Models';
import { usePromptWelcome } from './use-prompt-welcome';
import { SearchButton } from './SearchButton';
import useRootHistory from '../utils/use-root-history';
import { useFeatureServices } from '../use-feature-services';
import { createConstantData, createPartner } from '../utils/get-tracking-event-data';
import { getSelectedDealers } from '../utils/get-selected-dealers';
import { getFilterList } from '../utils/get-filter-list';
import { getDealers } from '../api/selectors/dealers';
import useFiltersCountQuery from '../api/use-filters-count-query';
import { UserLocationContext } from '../UserLocation/UserLocationContext';
import { DealerData, DealerResponse, FiltersResponse, FiltersResponseKey, ResponseSelector } from '../types';
import { getSingleSelectedDealer } from '../utils/get-single-selected-dealer';
import { useAppliedFilterStore } from '../store/filtersv2';
import useDealersQuery from '../api/use-dealers-query';

export default () => {

  usePromptWelcome();
  useRootHistory();

  const sectionRef = createRef<HTMLDivElement>();
  const { tracking } = useFeatureServices();
  const [sectionHeight, setSectionHeight] = useState(0);

  const { postalCode } = useContext(UserLocationContext);
  const { applied } = useAppliedFilterStore();
  const { dealer, distance } = applied;
  const getInventoryTotal: ResponseSelector<FiltersResponse, FiltersResponse[FiltersResponseKey.INVENTORY_TOTAL]> = res => res?.inventory_total;
  const { data: inventory_total } = useFiltersCountQuery<FiltersResponse, FiltersResponse[FiltersResponseKey.INVENTORY_TOTAL]>({ select: getInventoryTotal });
  const { data: all_dealers } = useDealersQuery<DealerResponse, DealerData[]>({select: getDealers(distance)});
  const partner = getSingleSelectedDealer();

  useEffect(() => {
    if (sectionRef?.current) {
      const offsetTop = sectionRef?.current?.offsetTop || 0;
      const offsetHeight = sectionRef?.current?.offsetHeight || 0;
      const height = offsetTop + offsetHeight;
      setSectionHeight(height);
    }
  }, [sectionRef]);

  useEffect(() => {
    if (inventory_total && postalCode && distance && dealer && all_dealers && applied) {
      tracking.track('VWBasic_FilterSearchResult_Load', {
        ...createConstantData(),
        partner: createPartner(partner),
        filter: {
          type: "complex",
          name: "Model counts",
          numberOfResults: inventory_total,
          filterlist: [
            {
              type: "single_value",
              name: "ZIP",
              values: [postalCode]
            },
            {
              type: "single_value",
              name: "DI",
              values: [distance]
            },
            {
              type: "multi_value",
              name: "DID",
              values: [getSelectedDealers(dealer as string[], all_dealers as DealerData[], 'dealer_id')]
            },
            ...getFilterList(applied),
          ]
        }
      });
    }
  }, [inventory_total]);

  return (
    <>
      <Header />
      <PageSummary />
      <FilterBar />
      <Models ref={sectionRef} />
      <SearchButton sectionHeight={sectionHeight} />
    </>
  );
};
